import "./GarageDoorPanelReplacement.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageManifesto from "./sections/GarageManifesto";
import GarageServices from "./sections/GarageServices";
import GaragePartners from "./sections/GaragePartners";
import GarageProcess from "./sections/GarageProcess";
import Whyus from "./sections/Whyus";
import GarageComparison from "./sections/GarageComparison";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import ServiceAreas from "./sections/ServiceAreas";
import SiteFooter from "./sections/SiteFooter";
export default function GarageDoorPanelReplacementPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageManifesto />
      <GarageServices />
      <GaragePartners />
      <GarageProcess />
      <Whyus />
      <GarageComparison />
      <Testimonials />
      <GarageFaq />
      <GarageCta />
      <ServiceAreas />
      <SiteFooter />
    </div>;
}